<template>
  <div class="bjplfx-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-button-group>
            <el-button :type="searchForm.wmr===0?'primary':''" size="small" @click="updataWmr(0)">周次</el-button>
            <el-button :type="searchForm.wmr===1?'primary':''" size="small" @click="updataWmr(1)">月次</el-button>
            <el-button :type="searchForm.wmr===2?'primary':''" size="small" @click="updataWmr(2)">类型</el-button>
          </el-button-group>
          <el-form style="float: right;" :inline="true" size="small" :model="searchForm"  @submit.native.prevent >
            <el-form-item label="选择日期">
              <el-date-picker
                v-model="searchForm.time"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button  icon="el-icon-s-data" type="primary" @click="getData">统计</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row :gutter="20">
              <el-col :span="24">
                <GraphicsChart class="Highcharts" id="llOption" :option="llOption"/>
              </el-col>
              <el-col :span="24">
                <div style="margin-bottom:20px;">
                  <el-table
                    :data="weekData"
                    stripe
                    style="width: 100%">
                    <el-table-column
                      prop="week"
                      align="center"
                      label="周次">
                      <template slot-scope="scope">
                        <span>{{ scope.row.week===0?'累计':scope.row.week+'周'}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="testBatch"
                      align="center"
                      label="检验批次">
                      <template slot-scope="scope">
                        <span>{{ scope.row.testBatch}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="合格批次">
                      <template slot-scope="scope">
                        <span>{{ scope.row.passBatch}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="不合格批次">
                      <template slot-scope="scope">
                        <span>{{ scope.row.badBatch}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passRate"
                      align="center"
                      label="批次合格率">
                      <template slot-scope="scope">
                        <span>{{ scope.row.passBatchRate}}%</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passRate"
                      align="center"
                      label="批次不合格率">
                      <template slot-scope="scope">
                        <span>{{ scope.row.badBatchRate}}%</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="来料数量">
                      <template slot-scope="scope">
                        <span>{{ scope.row.incomnum}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="检验数量">
                      <template slot-scope="scope">
                        <span>{{ scope.row.testnum}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="合格数量">
                      <template slot-scope="scope">
                        <span>{{ scope.row.passnum}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="不合格数量">
                      <template slot-scope="scope">
                        <span>{{ scope.row.badnum}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passRate"
                      align="center"
                      label="数量合格率">
                      <template slot-scope="scope">
                        <span>{{ scope.row.passnumRate}}%</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passRate"
                      align="center"
                      label="数量不合格率">
                      <template slot-scope="scope">
                        <span>{{ scope.row.badnumRate}}%</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div style="margin-bottom:20px;">
                  <el-table
                    :data="monthData"
                    stripe
                    style="width: 100%">
                    <el-table-column
                      align="center"
                      label="月次">
                      <template slot-scope="scope">
                        <span>{{ scope.row.month===0?'累计':scope.row.month+'月'}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="testBatch"
                      align="center"
                      label="检验批次">
                      <template slot-scope="scope">
                        <span>{{ scope.row.testBatch}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="合格批次">
                      <template slot-scope="scope">
                        <span>{{ scope.row.passBatch}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="不合格批次">
                      <template slot-scope="scope">
                        <span>{{ scope.row.badBatch}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passRate"
                      align="center"
                      label="批次合格率">
                      <template slot-scope="scope">
                        <span>{{ scope.row.passBatchRate}}%</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passRate"
                      align="center"
                      label="批次不合格率">
                      <template slot-scope="scope">
                        <span>{{ scope.row.badBatchRate}}%</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="来料数量">
                      <template slot-scope="scope">
                        <span>{{ scope.row.incomnum}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="检验数量">
                      <template slot-scope="scope">
                        <span>{{ scope.row.testnum}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="合格数量">
                      <template slot-scope="scope">
                        <span>{{ scope.row.passnum}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="不合格数量">
                      <template slot-scope="scope">
                        <span>{{ scope.row.badnum}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passRate"
                      align="center"
                      label="数量合格率">
                      <template slot-scope="scope">
                        <span>{{ scope.row.passnumRate}}%</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passRate"
                      align="center"
                      label="数量不合格率">
                      <template slot-scope="scope">
                        <span>{{ scope.row.badnumRate}}%</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div style="margin-bottom:20px;">
                  <el-table
                    :data="rawTypeData"
                    stripe
                    style="width: 100%">
                    <el-table-column
                      align="center"
                      label="材料类型">
                      <template slot-scope="scope">
                        <span>{{ scope.row.type==='0'?'累计': scope.row.type}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="testBatch"
                      align="center"
                      label="检验批次">
                      <template slot-scope="scope">
                        <span>{{ scope.row.testBatch}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="合格批次">
                      <template slot-scope="scope">
                        <span>{{ scope.row.passBatch}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="不合格批次">
                      <template slot-scope="scope">
                        <span>{{ scope.row.badBatch}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passRate"
                      align="center"
                      label="批次合格率">
                      <template slot-scope="scope">
                        <span>{{ scope.row.passBatchRate}}%</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passRate"
                      align="center"
                      label="批次不合格率">
                      <template slot-scope="scope">
                        <span>{{ scope.row.badBatchRate}}%</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="来料数量">
                      <template slot-scope="scope">
                        <span>{{ scope.row.incomnum}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="检验数量">
                      <template slot-scope="scope">
                        <span>{{ scope.row.testnum}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="合格数量">
                      <template slot-scope="scope">
                        <span>{{ scope.row.passnum}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passBatch"
                      align="center"
                      label="不合格数量">
                      <template slot-scope="scope">
                        <span>{{ scope.row.badnum}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passRate"
                      align="center"
                      label="数量合格率">
                      <template slot-scope="scope">
                        <span>{{ scope.row.passnumRate}}%</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="passRate"
                      align="center"
                      label="数量不合格率">
                      <template slot-scope="scope">
                        <span>{{ scope.row.badnumRate}}%</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="card-body" style="margin-top: 20px">
          <el-row :gutter="20">
            <el-col :span="14">
              <div style="margin-bottom: 10px">
                <el-form>
                  <el-form-item label="选择周次">
                    <el-select v-model="weekReportNum" placeholder="请选择周次" size="mini" @change="selectWeekReport()">
                      <el-option
                        v-for="item in weekData"
                        :key="item.week"
                        :label="item.week===0?'累计':item.week+'周'"
                        :value="item.week">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
              <div style="margin-bottom:100px">
                <div style="font-size: 30px;margin-left: 40%">产 品 质 量 周 报 表</div>
                <div>
                  <el-table
                    :data="weekReportSeries"
                    stripe
                    style="width: 100%">
                    <el-table-column
                      prop="testtime"
                      align="center"
                      label="检验情况">
                      <template slot-scope="scope">
                        <span>{{ scope.row.name}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-for="(item,index) in weekReportCategories"
                      prop="testtime"
                      align="center"
                      :label="item">
                      <template slot-scope="scope">
                        <span>{{ scope.row.name==='合格率'?scope.row.data[index]+'%':scope.row.data[index]}}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div style="font-size: 30px;margin-left: 40%; margin-top: 100px">不 良 类 别 周 报 表</div>
                <div>
                  <el-table
                    :data="badTypeSeries"
                    stripe
                    style="width: 100%">
                    <el-table-column
                      prop="testtime"
                      align="center"
                      label="检验情况">
                      <template slot-scope="scope">
                        <span>{{ scope.row.name}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-for="(item,index) in badTypeCategories"
                      prop="testtime"
                      align="center"
                      :label="item">
                      <template slot-scope="scope">
                        <span>{{ scope.row.name==='不合格率'?scope.row.data[index]+'%':scope.row.data[index]}}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <GraphicsChart class="Highcharts" id="weekOption" :option="weekOption"/>
              <GraphicsChart class="Highcharts" id="badTypeOption" :option="badTypeOption"/>
            </el-col>
          </el-row>
        </div>
        <div class="card-body" style="margin-top: 20px">
          <el-row :gutter="20">
            <el-col :span="14">
              <div style="margin-bottom: 10px">
                <el-form>
                  <el-form-item label="选择月次">
                    <el-select v-model="monthNum" placeholder="请选择月次" size="mini" @change="selectMonth()">
                      <el-option
                        v-for="item in monthData"
                        :key="item.month"
                        :label="item.month===0?'累计':item.month+'月'"
                        :value="item.month">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
              <div style="margin-bottom:100px">
                <div style="font-size: 30px;margin-left: 35%">{{this.monthNum===0?'累 计':this.monthNum+' 月'}} 来 料 数 据 汇 总</div>
                <table id="datatable">
                  <thead>
                    <tr>
                      <th>项目</th>
                      <th>总数</th>
                      <th>合格</th>
                      <th>不合格</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>批次</th>
                      <td>{{month.testBatch}}</td>
                      <td>{{month.passBatch}}</td>
                      <td>{{month.badBatch}}</td>
                    </tr>
                    <tr>
                      <th>占比</th>
                      <td>100%</td>
                      <td>{{month.passBatchRate}}%</td>
                      <td>{{month.badBatchRate}}%</td>
                    </tr>
                    <tr>
                      <th>数量</th>
                      <td>{{month.testnum}}</td>
                      <td>{{month.passnum}}</td>
                      <td>{{month.badnum}}</td>
                    </tr>
                    <tr>
                      <th>占比</th>
                      <td>100%</td>
                      <td>{{month.passnumRate}}%</td>
                      <td>{{month.badnumRate}}%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </el-col>
            <el-col :span="8">
              <GraphicsChart class="Highcharts" id="circleOption" :option="circleOption"/>
            </el-col>
          </el-row>
        </div>
        <div class="card-body" style="margin-top: 20px">
          <el-row :gutter="20">
            <el-col :span="14">
              <div style="margin-bottom: 10px">
                <el-form>
                  <el-form-item label="选择周次">
                    <el-select v-model="weekNum" placeholder="选择周次" size="mini" @change="selectWeek()">
                      <el-option
                        v-for="item in weekData"
                        :key="item.week"
                        :label="item.week===0?'累计':item.week+'周'"
                        :value="item.week">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
              <div style="margin-bottom:100px">
                <div style="font-size: 30px;margin-left: 35%">{{this.weekNum===0?'累 计':this.weekNum+' 周'}} 来 料 数 据 汇 总</div>
                <table id="datatable">
                  <thead>
                  <tr>
                    <th>项目</th>
                    <th>总数</th>
                    <th>合格</th>
                    <th>不合格</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th>批次</th>
                    <td>{{week.testBatch}}</td>
                    <td>{{week.passBatch}}</td>
                    <td>{{week.badBatch}}</td>
                  </tr>
                  <tr>
                    <th>占比</th>
                    <td>100%</td>
                    <td>{{week.passBatchRate}}%</td>
                    <td>{{week.badBatchRate}}%</td>
                  </tr>
                  <tr>
                    <th>数量</th>
                    <td>{{week.testnum}}</td>
                    <td>{{week.passnum}}</td>
                    <td>{{week.badnum}}</td>
                  </tr>
                  <tr>
                    <th>占比</th>
                    <td>100%</td>
                    <td>{{week.passnumRate}}%</td>
                    <td>{{week.badnumRate}}%</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </el-col>
            <el-col :span="8">
              <GraphicsChart class="Highcharts" id="weekCircleOption" :option="weekCircleOption"/>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { selectRawLedgerInfo } from '@/api/erp'
import GraphicsChart from '@/components/Charts/GraphicsChart'
export default {
  name: 'yclfx',
  components: { GraphicsChart },
  computed: {
    user: getUser
  },
  data() {
    return {
      searchForm: {
        time: [],
        wmr: 0
      },
      rawLedgers: [],
      weekData: [],
      monthData: [],
      rawTypeData: [],
      categories: [],
      series: [],
      llOption: {
        title: false,
        credits: {
          enabled: false
        }
      },
      weekReportNum: null, // 周报告周次
      weekReportSeries: [], // 周报质量数据
      weekReportCategories: [], // 周报质量数据x轴
      weekOption: {
        title: false,
        credits: {
          enabled: false
        }
      },
      badTypeSeries: [],
      badTypeCategories: [],
      badTypeOption: {
        title: false,
        credits: {
          enabled: false
        }
      },
      monthNum: null, // 选择月次
      month: {},
      monthCircleSeries: [],
      circleOption: {
        title: false,
        exporting: {
          enabled: true
        },
        credits: {
          enabled: false
        }
      },
      weekNum: null, // 选择周次
      week: {},
      weekCircleSeries: [],
      weekCircleOption: {
        title: false,
        exporting: {
          enabled: true
        },
        credits: {
          enabled: false
        }
      }
    }
  },
  created() {
    const myDate = new Date()
    const year = myDate.getFullYear()
    let month = myDate.getMonth() + 1
    let day = myDate.getDate()
    month = month > 9 ? month + '' : '0' + month
    day = day > 9 ? day + '' : '0' + day
    this.searchForm.time.push(year + '-' + month + '-01')
    this.searchForm.time.push(year + '-' + month + '-' + day)
    this.getData()
  },
  methods: {
    updataWmr(val) {
      this.searchForm.wmr = val
      this.getData()
    },
    selectWeek() {
      for (let a of this.weekData) {
        if (this.weekNum === a.week) {
          this.week = a
        }
      }
      this.weekCircleSeries = [
        {
          name: '合格',
          y: this.week.passBatchRate,
          sliced: true,
          selected: true
        },
        {
          name: '不合格',
          y: this.week.badBatchRate
        }
      ]
      const chart = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        credits: {
          enabled: false
        },
        title: {
          text: '周数据对比图'
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.percentage:.1f} %'
            }
          }
        },
        series: [{
          name: '占比',
          colorByPoint: true,
          data: this.weekCircleSeries
        }]
      }
      this.weekCircleOption = chart
    },
    selectMonth() {
      for (let a of this.monthData) {
        if (this.monthNum === a.month) {
          this.month = a
        }
      }
      this.monthCircleSeries = [
        {
          name: '合格',
          y: this.month.passBatchRate,
          sliced: true,
          selected: true
        },
        {
          name: '不合格',
          y: this.month.badBatchRate
        }
      ]
      const chart = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        credits: {
          enabled: false
        },
        title: {
          text: '月数据对比图'
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.percentage:.1f} %'
            }
          }
        },
        series: [{
          name: '占比',
          colorByPoint: true,
          data: this.monthCircleSeries
        }]
      }
      this.circleOption = chart
    },
    selectWeekReport() {
      let weekReportCategories = []
      let weekReportSeries = []
      let testBatchData = []
      let passBatchData = []
      let passRateData = []
      let badTypeCategories = []
      let badTypeSeries = []
      if (this.weekReportNum === 0) {
        weekReportCategories.push('累计')
        weekReportSeries.push({ name: '检验批次', type: 'column', data: [this.weekData[this.weekData.length - 1].testBatch] })
        weekReportSeries.push({ name: '合格批次', type: 'column', data: [this.weekData[this.weekData.length - 1].passBatch] })
        weekReportSeries.push({ name: '合格率', type: 'spline', data: [this.weekData[this.weekData.length - 1].passBatchRate], yAxis: 1, tooltip: { valueSuffix: '%' }})
        for (let rl of this.rawLedgers) {
          for (let rbi of rl.rawBadInfoList) {
            let boolean = true
            for (let btc of badTypeCategories) {
              if (rbi.name === btc) {
                boolean = false
              }
            }
            if (boolean) {
              badTypeCategories.push(rbi.name)
            }
          }
        }
        let badnum = {
          name: '数量',
          data: [],
          type: 'column'
        }
        let bigSum = 0
        for (let btc of badTypeCategories) {
          let  miniSum = 0
          for (let rl of this.rawLedgers) {
            for (let rbi of rl.rawBadInfoList) {
              if (btc === rbi.name) {
                miniSum += rbi.num
              }
            }
          }
          badnum.data.push(miniSum)
          bigSum += miniSum
        }
        badnum.data.push(bigSum)
        let badnumRate = {
          name: '不合格率',
          data: [],
          tooltip: { valueSuffix: ' %' },
          type: 'spline',
          yAxis: 1
        }
        for (let num of badnum.data) {
          let rate = 0
          if (bigSum > 0) {
            rate = parseFloat((num / bigSum * 100).toFixed(2))
          } else {
            rate = 0
          }
          badnumRate.data.push(rate)
        }
        badTypeCategories.push('累计')
        badTypeSeries.push(badnum, badnumRate)
      } else {
        let a = []
        for (let rl of this.rawLedgers) {
          if (this.weekReportNum === rl.week) {
            a.push(rl)
          }
        }
        for (let _a of a) {
          let boolean = true
          for (let _b of weekReportCategories) {
            if (_a.testtime === _b) {
              boolean = false
            }
          }
          if (boolean) {
            weekReportCategories.push(_a.testtime)
          }
        }
        let testBatchSum = 0
        let passBatchSum = 0
        let passRateSum = 0.00
        for (let _b of weekReportCategories) {
          let testBatch = 0
          let passBatch = 0
          let passRate = 0.00
          for (let _a of a) {
            if (_b === _a.testtime) {
              testBatch++
              if (_a.deter === 1) {
                passBatch++
              }
            }
          }
          if (testBatch !== 0) {
            passRate = parseFloat((passBatch / testBatch * 100).toFixed(2))
          }
          testBatchData.push(testBatch)
          passBatchData.push(passBatch)
          passRateData.push(passRate)

          testBatchSum += testBatch
          passBatchSum += passBatch
        }
        if (testBatchSum !== 0) {
          passRateSum = parseFloat((passBatchSum / testBatchSum * 100).toFixed(2))
        } else {
          passRateSum = 0.00
        }
        testBatchData.push(testBatchSum)
        passBatchData.push(passBatchSum)
        passRateData.push(passRateSum)
        weekReportSeries.push({ name: '检验批次', type: 'column', data: testBatchData })
        weekReportSeries.push({ name: '合格批次', type: 'column', data: passBatchData })
        weekReportSeries.push({ name: '合格率', type: 'spline', data: passRateData, yAxis: 1, tooltip: { valueSuffix: '%' }})
        weekReportCategories.push('累计')

        // 分割线
        for (let rl of this.rawLedgers) {
          if (rl.week === this.weekReportNum) {
            for (let rbi of rl.rawBadInfoList) {
              let boolean = true
              for (let btc of badTypeCategories) {
                if (rbi.name === btc) {
                  boolean = false
                }
              }
              if (boolean) {
                badTypeCategories.push(rbi.name)
              }
            }
          }
        }
        let badnum = {
          name: '数量',
          data: [],
          type: 'column'
        }
        let bigSum = 0
        for (let btc of badTypeCategories) {
          let  miniSum = 0
          for (let rl of this.rawLedgers) {
            if (rl.week === this.weekReportNum) {
              for (let rbi of rl.rawBadInfoList) {
                if (btc === rbi.name) {
                  miniSum += rbi.num
                }
              }
            }
          }
          badnum.data.push(miniSum)
          bigSum += miniSum
        }
        badnum.data.push(bigSum)
        let badnumRate = {
          name: '不合格率',
          data: [],
          tooltip: { valueSuffix: ' %' },
          type: 'spline',
          yAxis: 1
        }
        for (let num of badnum.data) {
          let rate = 0
          if (bigSum > 0) {
            rate = parseFloat((num / bigSum * 100).toFixed(2))
          } else {
            rate = 0
          }
          badnumRate.data.push(rate)
        }
        badTypeCategories.push('累计')
        badTypeSeries.push(badnum, badnumRate)
        // 分割线
      }
      this.weekReportCategories = weekReportCategories
      this.weekReportSeries = weekReportSeries
      this.badTypeCategories = badTypeCategories
      this.badTypeSeries = badTypeSeries
      // let s = _a.testtime.split('-')
      // let s1 = new Date(s[0], parseInt(s[1] - 1), s[2])
      // let  s3 = String(s1.getDay()).replace('0', '日').replace('1', '一').replace('2','二').replace('3', '三').replace('4', '四').replace('5', '五').replace('6', '六')
      // let weekday = '星期' + s3
      const chart = {
        chart: {
          zoomType: 'xy'
        },
        credits: {
          enabled: false
        },
        lang: {
          printChart: '打印图表',
          downloadPNG: '下载JPEG 图片',
          downloadJPEG: '下载JPEG文档',
          downloadPDF: '下载PDF 图片',
          downloadSVG: '下载SVG 矢量图',
          contextButtonTitle: '下载图片'
        },
        title: {
          text: '产品质量周报'
        },
        xAxis: {
          categories: this.weekReportCategories,
          crosshair: true
        },
        yAxis: [{ // Primary yAxis
          labels: {
            format: '{value}'
          },
          allowDecimals: false,
          title: {
            text: '批次'
          }
        }, { // Secondary yAxis
          title: {
            text: '百分比'
          },
          labels: {
            format: '{value}%'
          },
          opposite: true
        }],
        tooltip: {
          shared: true
        },
        plotOptions: {
          column: {
            borderWidth: 0
          }
        },
        series: this.weekReportSeries
      }
      this.weekOption = chart

      const chart1 = {
        chart: {
          zoomType: 'xy'
        },
        credits: {
          enabled: false
        },
        lang: {
          printChart: '打印图表',
          downloadPNG: '下载JPEG 图片',
          downloadJPEG: '下载JPEG文档',
          downloadPDF: '下载PDF 图片',
          downloadSVG: '下载SVG 矢量图',
          contextButtonTitle: '下载图片'
        },
        title: {
          text: '不良类别周报'
        },
        xAxis: {
          categories: this.badTypeCategories,
          crosshair: true
        },
        yAxis: [{ // Primary yAxis
          labels: {
            format: '{value}'
          },
          allowDecimals: false,
          title: {
            text: '批次'
          }
        }, { // Secondary yAxis
          title: {
            text: '百分比'
          },
          labels: {
            format: '{value}%'
          },
          opposite: true
        }],
        tooltip: {
          shared: true
        },
        plotOptions: {
          column: {
            borderWidth: 0
          }
        },
        series: this.badTypeSeries
      }
      this.badTypeOption = chart1
    },
    getData() {
      let startTime = ''
      let endTime = ''
      if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
        startTime = this.searchForm.time[0]
        endTime = this.searchForm.time[1]
      }
      const data = {
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role,
        startTime: startTime,
        endTime: endTime,
        wmr: this.searchForm.wmr
      }
      selectRawLedgerInfo(data).then(response => {
        this.rawLedgers = response.data.rawLedgers
        this.weekData = response.data.week
        this.monthData = response.data.month
        this.rawTypeData = response.data.rawType
        this.categories = response.data.categories
        this.series = response.data.series
        this.weekReportNum = response.data.week[0].week
        this.monthNum = response.data.month[0].month
        this.weekNum = response.data.week[0].week
        for (const s of this.series) {
          if (s.name.indexOf('合格率') >= 0) {
            s.yAxis = 1
            s.tooltip = { valueSuffix: '%' }
          }
        }
        const chart = {
          chart: {
            zoomType: 'xy'
          },
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          credits: {
            enabled: false
          },
          title: {
            text: '原材料分析'
          },
          xAxis: {
            categories: this.categories,
            crosshair: true
          },
          yAxis: [{ // Primary yAxis
            labels: {
              format: '{value}'
            },
            allowDecimals: false,
            title: {
              text: '批次/数量'
            }
          }, { // Secondary yAxis
            title: {
              text: '百分比'
            },
            labels: {
              format: '{value}%'
            },
            opposite: true
          }],
          tooltip: {
            shared: true
          },
          plotOptions: {
            column: {
              borderWidth: 0
            }
          },
          series: this.series
        }
        this.selectWeekReport()
        this.selectMonth()
        this.selectWeek()
        this.llOption = chart
      })
    }
  }
}
</script>

<style scoped>
  #datatable {
    border: 1px solid #ccc;
    border-collapse: collapse;
    border-spacing: 0;
    font-size: 12px;
  }
  td,th {
    border: 1px solid #ccc;
    padding: 4px 20px;
    text-align: center;
    width: 230px;
    height: 50px;
  }
</style>
